import { supabase } from '@/core/database/supabase';
import { permissionEngine } from '@/core/permissions';
import type { EquipmentRequestRecord } from '../types/equipmentRequests.types';

export const equipmentRequestsListService = {
  async getEquipmentRequests(companyId: string, userId: string): Promise<EquipmentRequestRecord[]> {
    await permissionEngine.assert(userId, 'equipment.requests.view', { companyId });
    
    const { data, error } = await supabase
      .from('equipment_requests')
      .select(`
        *,
        project:projects(id, name),
        requester:user_profiles!requester_id(id, full_name, avatar_path)
      `)
      .eq('company_id', companyId)
      .order('created_at', { ascending: false });

    if (error) throw error;
    
    return (data || []).map(item => ({
      id: item.id,
      companyId: item.company_id,
      projectId: item.project_id,
      requesterId: item.requester_id,
      title: item.title,
      description: item.description,
      neededFrom: item.needed_from,
      neededUntil: item.needed_until,
      statusCode: item.status_code,
      priority: item.priority,
      approvedBy: item.approved_by,
      approvedAt: item.approved_at,
      createdAt: item.created_at,
      updatedAt: item.updated_at,
      project: item.project,
      requester: item.requester
    }));
  }
};
